"use strict";
exports.__esModule = true;
exports.FLEX_ANYWHERE_RENT_AMOUNT_CONTENT = void 0;
exports.FLEX_ANYWHERE_RENT_AMOUNT_CONTENT = {
    HEADER: 'How much is your rent bill?',
    BODY_ONE: 'Enter the ',
    BODY_BOLD: 'total amount ',
    BODY_TWO: "due on this month's rent bill, including any fees (like utilities, trash fees, etc.) as it appears in your rent portal.",
    RENT_INPUT_LABEL: 'Rent bill amount',
    AMOUNT_CHANGES: 'What if there are extra fees?',
    AMOUNT_CHANGE_MODAL_HEADER: 'What if there are extra fees?',
    AMOUNT_CHANGE_MODAL_BODY_ONE: 'We understand that sometimes properties charge additional fees that don’t appear on your bill. Don’t worry! Your rent payment will still be approved if it’s a little higher than the bill amount.',
    AMOUNT_CHANGE_MODAL_BODY_TWO: 'Note that if there is a big difference between your reported rent and the attempted payment, we’ll follow up for more information.',
    AMOUNT_CHANGE_MODAL_CTA: 'Done',
    CTA: 'Continue'
};
